module.exports = __webpack_public_path__ + "img/palm-tree.b24d7c7e.png";